// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"16bfc5b3","223":"1fa499d6","239":"cd843b93","512":"84c8bc81","739":"9dd7758f","835":"e1825fdc","958":"a3c5d278","968":"4f0ef379"}[chunkId] + ".chunk.js";
};